<input matInput type="text"
       class="amount-input"
       [ngModel]="amount"
       (click)="amountClicked($event)"
       (change)="amountChanged($event)">
<div class="format-amount" [ngClass]="{ 'zero': amount === 0, 'negative': amount < 0 }">
  {{ amount | chf }}
</div>
